module.exports = __webpack_public_path__ + "static/img/zoom_btn1.2e34395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/zoom_btn1.png
// module id = hP+t
// module chunks = 4